import React, { forwardRef } from "react";
import { Dialog, Slide, Typography } from "@material-ui/core";
import sendMemberInviteEmail from "../../graphql";
import InviteForm from "../../invite-form";

import DialogTitle from "../dialog-title";

import styles, { useSlideStyles } from "./slide-dialog.styles";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const SlideDialog = ({
  openSlideDialog,
  setOpenSlideDialog,
  handleClickOpenDialog,
  handleClose,
  isLoading
}) => {
  const classes = useSlideStyles();

  return (
    <Dialog
      classes={{
        paper: classes.dialog
      }}
      open={openSlideDialog}
      TransitionComponent={Transition}
      keepMounted
      transitionDuration={{ enter: 1000, exit: 100 }}
      onClose={() => {
        setOpenSlideDialog(false);
      }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose} />
      <div style={styles.titleContainer}>
        <Typography id="dialog-title" style={styles.dialogTitleText}>
          Invite New Staff Member
        </Typography>
        <Typography id="dialog-sub-title" style={styles.dialogSubTitleText}>
          Send emails with a sign up link direct to potential candidates and
          have them sign up directly to the Rota system.
        </Typography>
      </div>
      <div style={styles.dialogContent}>
        <div id="form-container" style={styles.formContainer}>
          <p style={styles.formTitle}>Account Details</p>
          <InviteForm
            setOpenSlideDialog={setOpenSlideDialog}
            handleClickOpenDialog={handleClickOpenDialog}
            handleClose={handleClose}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default sendMemberInviteEmail(SlideDialog);
